export const DEFAULT_USER_NAME = "";
export const DEFAULT_USER_ROLE = "Admin";

export const HEADER_DROPDOWN_OPTIONS = [
  "All",
  "Trending Plans",
  "Featured Plans",
];

export const HEADER_SEARCH_OPTIONS = [
  "San Francisco",
  "New York",
  "Seattle",
  "Los Angeles",
  "Chicago",
];
